// Submissão direta para HubSpot Forms API (v3).
// Docs: https://legacydocs.hubspot.com/docs/methods/forms/submit_form_v3_authentication
//
// Usamos os IDs oficiais e enviamos com os *internal names* das propriedades
// do HubSpot (firstname, lastname, email, ...). Isso garante que os dados
// caiam corretamente na ficha do contato.

export const HS_PORTAL_ID = "5455473";
/** GUID do formulário de download no HubSpot — preencher. Vazio = não envia. */
export const HS_DOWNLOAD_FORM_ID = "";
export const HS_NEWSLETTER_FORM_ID = "d0c2e538-e8bb-4fa5-a78f-77797a6281e3";

export type HubspotField = {
  /** Internal name da propriedade no HubSpot (ex.: "firstname", "email"). */
  name: string;
  value: string;
  /** Alguns portais/forms exigem objectTypeId. 0-1 = contact. */
  objectTypeId?: string;
};

interface SubmitOptions {
  portalId?: string;
  formId: string;
  fields: HubspotField[];
  /** Opcional. Nome da página / origem lógica (ex.: "blog_sidebar"). */
  pageName?: string;
  /** Opcional. Consentimento LGPD/GDPR. */
  consent?: {
    consentToProcess?: boolean;
    text?: string;
    communications?: Array<{
      value: boolean;
      subscriptionTypeId: number;
      text: string;
    }>;
  };
}

function readCookie(name: string): string | undefined {
  if (typeof document === "undefined") return undefined;
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : undefined;
}

export async function submitHubspotForm({
  portalId = HS_PORTAL_ID,
  formId,
  fields,
  pageName,
  consent,
}: SubmitOptions): Promise<void> {
  const url = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`;

  const context: Record<string, unknown> = {};
  const hutk = readCookie("hubspotutk");
  if (hutk) context.hutk = hutk;
  if (typeof window !== "undefined") {
    context.pageUri = window.location.href;
    context.pageName = pageName || document.title;
  }

  const payload: Record<string, unknown> = {
    fields: fields.map((f) => ({
      objectTypeId: f.objectTypeId ?? "0-1",
      name: f.name,
      value: f.value,
    })),
    context,
  };
  if (consent) payload.legalConsentOptions = { consent };

  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    let detail = "";
    try {
      detail = JSON.stringify(await res.json());
    } catch {
      /* noop */
    }
    throw new Error(`HubSpot form submit failed (${res.status}): ${detail}`);
  }
}
